import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlEditorSelectBoxDatasource',
})
export class HtmlEditorSelectBoxDatasourcePipe implements PipeTransform {
  constructor() {}

  transform(values: string[]) {
    return [];
  }
}
